<!--
 * @Description: 
 * @Author: zml
 * @Date: 2025-03-11 10:46:43
 * @LastEditors: zml
 * @LastEditTime: 2026-07-02 10:36:56
-->
<template>
  <div class="logo-box">
    <div class="logo-navBar container">
      <div class="logo-navBar-left">
        <ul>
          <li @click="goLogin">
            <span style="margin-right: 10px;">{{ userInfo.id ? $hs('退出登录','Log out','Salir del login'):$hs('登录','Sign In','inicio')}}</span>
            <el-divider direction="vertical"></el-divider>
          </li>
          <li>
            <span style="margin-right: 10px;" @click="goCart">{{ $hs('我的订单','My Order','Mi pedido') }}</span>
            <el-divider direction="vertical"></el-divider>
          </li>
          <!-- <li @click="commandMenu">
            <span>{{$hs('Chinese','español','English')}}</span>
          </li>-->
          <li>
            <el-dropdown trigger="click" @command="commandMenu">
              <span style="color: #dedede;">
                {{ LanguageType }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item command="espa">español</el-dropdown-item> -->
                <el-dropdown-item command="english">English</el-dropdown-item>
                <el-dropdown-item command="chinese">中文(Chinese)</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <div class="logo-navBar-right">
        <ul>
          <li>
            <img src="../../assets/LLH_follow/email.png" alt style="width: 42px;height: 42px;margin-right: 12px;" />
            <a href="mailto:info@Joeletoys.com" style="color:#dedede; text-decoration: none;">35887914@qq.com</a>
          </li>
          <li>
            <img src="../../assets/LLH_follow/phone.png" alt style="width: 42px;height: 42px;margin-right: 12px;" />
            <span>18779782000</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="container logo-container">
      <div class="left">
        <div class="logo" @click="$router.push({path: '/home'})">
          <img :src="getSetting.logo" />
        </div>
        <span class="company-name">Union World Toys</span>
      </div>
      <div class="right">
        <div class="input-box">
          <el-input v-model="keywords" :placeholder="$t('LLH.logoBox.placeholder')" @keyup.enter.native="onSearch">
            <el-button slot="append" @click="onSearch">{{$t('LLH.logoBox.search')}}</el-button>
          </el-input>
        </div>
        <div class="nav-box">
          <el-button plain round @click="commandMenu">{{$hs('English','Chinese')}}</el-button>
          <el-button plain round @click="goLogin">{{ userInfo.id ? $hs('退出登录','Log out'):$hs('登录','Sign In')}}</el-button>
          <div class="cart-box">
            <i class="icon-hsrj icon-gouwuche-wu" @click="goCart">
              <div class="cart-num">{{ userInfo.id ? gettingCart.length : getEnquiry[0].list.length }}</div>
            </i>
            <div class="cart-label">{{ $hs('购物车','Cart') }}</div>
          </div>
        </div>
      </div>
    </div>-->
    <login-modal ref="loginModal" @register="register" @forgetpassword="forgetpassword"></login-modal>
    <register-model ref="registerModel" @login="login"></register-model>
    <reset-pass-model ref="resetPassModel" @login="login"></reset-pass-model>
    <update-info ref="updateInfo"></update-info>
  </div>
</template>
<script>
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import resetPassModel from '@/components/memberModal/resetPassModel.vue'
import updateInfo from '@/components/memberModal/updateInfo.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { setDocumentTitle } from '@/utils/domUtil'
export default {
  name: 'logoBox',
  components: {
    loginModal,
    registerModel,
    updateInfo,
    resetPassModel
  },
  data() {
    return {
      keywords: '',
      LanguageType: this.$i18n.locale == 'ru' ? 'español' : this.$i18n.locale == 'en' ? 'English' : '中文(Chinese)'
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters('setting', {
      getSetting: 'get_setting',
      getLanguageConfig: 'get_language_config'
    }),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),
  },
  methods: {
    ...mapActions('user', ['logout']),
    ...mapActions('operate', {
      set_language: 'set_language'
    }),
    // 登录
    login() {
      this.$refs.loginModal.open()
    },

    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    // 打开忘记密码
    forgetpassword() {
      this.$refs.resetPassModel.open()
    },
    // 更新信息
    updateInfo() {
      this.$refs.updateInfo.open()
    },

    // 跳转我的订单
    linkOrder() {
      if (Object.keys(this.userInfo).length > 0) {
        this.$router.push({ path: '/order' })
      } else {
        this.login()
      }
    },

    // 登录
    goLogin() {
      this.getScrollTop();
      if (Object.keys(this.userInfo).length > 0) {
        // this.updateInfo()
        this.$confirm(this.$hs('是否退出登录?', 'Log out?', '¿Cerrar sesión?'), this.$hs('退出登录', 'Log out', 'Cerrar la sesión'), {
          confirmButtonText: this.$hs('确定', 'Confirm', 'Confirmar confirmación'),
          cancelButtonText: this.$hs('取消', 'Cancel', 'cancelar'),
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('Token')
          localStorage.removeItem('userInfo')
          location.reload()
          this.$router.push('/home')
        }).catch(() => {
        });
      } else {
        this.login()
      }
    },
    getScrollTop() {
      localStorage.setItem('scrollTop', JSON.stringify(0))
    },
    // 跳转购物车
    goCart() {
      this.getScrollTop();
      if (Object.keys(this.userInfo).length > 0) {
        this.$router.push({ path: '/order' })
      } else {
        this.login()
      }
    },

    // 搜索
    onSearch() {
      if (this.$route.path !== '/product') {
        this.$router.push({
          name: 'product',
          params: { keywords: this.keywords }
        })
      }
      this.$bus.$emit('searchProduct', this.keywords)
    },

    // 高级搜索
    onAdvancedSearch() {
      this.$router.push('/home')
      this.$nextTick(() => {
        document.querySelector('#advanced-search').scrollIntoView(true)
      })
    },
    commandMenu(command) {
      if (command == 'espa') {
        this.LanguageType = 'español'
        this.$i18n.locale = 'ru'
        this.set_language('ru')
        setDocumentTitle(this.getSetting.title)
      }
      if (command == 'english') {
        this.LanguageType = 'English'
        this.$i18n.locale = 'en'
        this.set_language('en')
        setDocumentTitle(this.getSetting.enTitle)
      }
      if (command == 'chinese') {
        this.LanguageType = '中文(Chinese)'
        this.$i18n.locale = 'zh'
        this.set_language('zh')
        setDocumentTitle(this.getSetting.enTitle)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dropdown-menu__item:hover {
  background-color: #490d59;
  color: #fff;
}
.logo-box {
  width: 100%;
  background-color: #490d59;
  position: fixed;
  top: 0;
  z-index: 999;
  height: 62px;
  .logo-navBar {
    ul {
      display: flex;
      align-items: flex-start;
      margin-top: 9px;
      list-style: none;
    }
    ul li {
      color: #dedede;
      display: flex;
      align-items: center;
      margin-right: 20px;
      span {
        cursor: pointer;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;
  }

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;

    .left {
      min-width: 200px;
      display: flex;
      align-items: center;
      .logo {
        max-width: 100px;
        height: 100px;
        margin-right: 10px;
        cursor: pointer;

        img {
          width: auto;
          height: 100px;
        }
      }

      .company-name {
        flex: 1;
        font-size: 18px;
        overflow: hidden;
        font-weight: bold;
        color: #222222;
      }
    }

    .right {
      min-width: 200px;
      display: flex;
      justify-content: right;
      .input-box {
        width: 500px;
        margin: 0 20px 0 0;
        .el-input-group {
          border-radius: 24px !important;
          overflow: hidden;
          border: 1px solid #00923f;
          height: 48px;
          box-sizing: border-box;
          ::v-deep .el-input__inner {
            border: 0 !important;
            font-size: 16px;
            height: 48px;
          }

          ::v-deep .el-input-group__append {
            width: 90px;
            height: 48px;
            border-radius: 24px !important;
            border: 2px solid #fff;
            background: #00923f;
            text-align: center;
            font-size: 16px;
            box-sizing: border-box;
            color: #fff;
            cursor: pointer;
          }
        }
      }

      .nav-box {
        display: flex;
        align-items: center;
        font-size: 30px;

        .el-button {
          height: 48px;
          border-radius: 24px;
          font-size: 14px;
          border: 1px solid #00923f;
          color: #333333;
          margin: 0 20px 0 0;
          &:hover {
            color: #00923f;
          }
        }

        i {
          position: relative;
          padding: 0 5px 0;
          margin: 10px 0 0 0;

          .cart-num {
            display: inline-block;
            position: absolute;
            top: -5px;
            height: 18px;
            line-height: 18px;
            background-color: #00923f;
            border-radius: 8px;
            font-size: 12px;
            padding: 0px 5px;
            color: #fff;
            font-weight: normal;
          }
        }
        .cart-label {
          font-size: 14px;
          color: #333c4f;
          text-align: center;
        }

        .icon-gouwuche-you {
          font-size: 30px;
          color: #f2410f;
          margin: 0 !important;
        }
        .icon-gouwuche-wu {
          font-size: 30px;
          margin: 0 !important;
        }
        .cart-box {
          height: 48px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          &:hover {
            color: #00923f;
            cursor: pointer;
            .cart-label {
              color: #00923f;
            }
          }
        }
      }
    }
  }
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>